import CancelButton from '@/contexts/shared/components/buttons/CancelButton'
import DeleteButton from '@/contexts/shared/components/buttons/DeleteButton'
import { StyledDialog } from '@/contexts/shared/styles/StyledDialog'
import { deleteEvent } from '@/redux/actions/events'
import { Delete, CloseRounded } from '@mui/icons-material'
import { DialogTitle, Grid, Typography, Button, DialogActions, DialogContent } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

export const ConfirmDeleteModal = ({
  open,
  handleClose,
  eventSelected
}: { open: boolean; handleClose: () => void; eventSelected: any }) => {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  return (
    <StyledDialog open={open} onClose={handleClose} aria-describedby="title" aria-labelledby="desc">
      <DialogTitle>
        <Grid container justifyContent="space-between">
          <Typography variant="h6">
            {String(t('delete'))} {String(t('event'))}
          </Typography>
          <Button onClick={handleClose}>
            <CloseRounded />
          </Button>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Typography>{t('confirm-delete')}</Typography>
      </DialogContent>
      <DialogActions>
        <CancelButton onClick={handleClose}>{t('cancel')}</CancelButton>
        <DeleteButton
          endIcon={<Delete />}
          onClick={() => {
            dispatch(deleteEvent(eventSelected))
            handleClose()
          }}
        >
          {t('delete')}
        </DeleteButton>
      </DialogActions>
    </StyledDialog>
  )
}

export default ConfirmDeleteModal
